<div>
<div *ngIf="quota$ | async as quotaData; else loadingOrError">
    <span>Quota left: {{ quotaData.Quota_left }}</span>
</div>
<ng-template #loadingOrError>
    <span>Loading quota or no data available...</span>
</ng-template>
</div>